import request from './request';

export function getNobleLevels() {
  return request.get('/api/noble/levels');
}
export function getMyNoble() {
  return request.get('/api/noble/myNoble');
}
export function buyNoble(nobleLevelId) {
  return request.post('/api/noble/buy', { noble_level_id: nobleLevelId });
}
